<template lang="pug">
v-dialog(v-model="dialog" width="700")
  v-card
    v-card-title {{ title }}
    v-card-text
      //- Warning
      div.mb-6
        b Importante!
        span  Al cambiar la capacidad de producción de un producto, se actualizarán los
        b  Casos de Potencial Comercial
        span  comerciales asociadas a este producto.
      v-form(ref="form" @submit.prevent="onSubmit")
        v-row
          v-col(cols="12")
            v-select(
              label="Tipo de Capacidad"
              v-model="form.has_shared_capacity"
              outlined
              :items="capacityTypes"
              item-text="name"
              item-value="value"
            )
          v-col(v-if="form.has_shared_capacity" cols="12")
            v-autocomplete(
              label="Productos Combinables"
              placeholder="Seleccionar Productos Combinables"
              :search-input.sync="searchProductSharedCapacity"
              v-model="form.shared_capacity"
              :items="products"
              item-text="name"
              item-value="id"
              multiple
              chips
              outlined
            )
          v-col(cols="12")
            div(:id="WIZARD_ELEMENTS_ID.HELP_MONTHLY_PRODUCTION_CAPACITY")
              .d-flex
                NumberMaskedInput(
                  v-if="selectedBaseProduct"
                  label="Capacidad de producción o abastecimiento mensual promedio"
                  v-model="form.monthly_production_capacity"
                  :rules="v.monthly_production_capacity"
                  :suffix="selectedBaseProduct.unit_of_measure"
                )
                ShowInfoBtn.mt-4(style="height: 100%" @click="$refs.monthlyProductionCapacityInfoAlert.showAlert()")
              InfoAlert(:message="alertMessages.monthly_production_capacity" ref="monthlyProductionCapacityInfoAlert")
          v-col(cols="12")
            label.font-weight-bold(v-if="selectedBaseProduct") Estacionalidad (Capacidad Anual: {{form.monthly_production_capacity}} x 12 = {{form.monthly_production_capacity * 12}} {{selectedBaseProduct.unit_of_measure}})
            div.mb-3.d-block
              strong {{text1}} (Porcentaje actual
                span(:style="estimatedPercentage > 100 ? 'color: red;' : ''")  {{estimatedPercentage}}% / 100%
                span ):
              span  {{text2}}
        label.mb-3.d-block.red--text(v-if="validated && estimatedPercentage !== 100") La suma de los porcentajes debe sumar 100%
        v-row
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.january_production_percentage"
              label="Enero"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.february_production_percentage"
              label="Febrero"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.march_production_percentage"
              label="Marzo"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.april_production_percentage"
              label="Abril"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.may_production_percentage"
              label="Mayo"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.june_production_percentage"
              label="Junio"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.july_production_percentage"
              label="Julio"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.august_production_percentage"
              label="Agosto"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.september_production_percentage"
              label="Septiembre"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.october_production_percentage"
              label="Octubre"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.november_production_percentage"
              label="Noviembre"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
          v-col(cols="12" sm="4" md="3")
            v-text-field(
              v-model="form.december_production_percentage"
              label="Diciembre"
              outlined
              type="number"
              min="0"
              max="100"
              suffix="%"
              :rules="v.production_percentage"
            )
        .text-right
          v-btn(color="primary" outlined @click="handleCancel" :disabled="loading").mr-2 Cancelar
          v-btn(color="primary" type="submit" :loading="loading" :disabled="!isValid") Guardar
</template>
<script>
import { mapActions } from 'vuex'
import FormMixin from '@/components/mixins/FormMixin'
import validations from '@/shared/formValidations'
import debounce from 'debounce'
import ShowInfoBtn from '@/components/common/ShowInfoBtn.vue'
import InfoAlert from '@/components/common/InfoAlert.vue'
import { numberMaskFormat } from '@/utils/mask'
import NumberMaskedInput from '@/components/common/NumberMaskedInput.vue'
import { WIZARD_STEPS_EVENTS, WIZARD_ELEMENTS_ID } from '@/constants'
import { globalEmitter } from '@/utils/eventBus'

export default {
  mixins: [FormMixin],
  components: {
    ShowInfoBtn,
    InfoAlert,
    NumberMaskedInput
  },
  data () {
    return {
      WIZARD_ELEMENTS_ID,
      dialog: false,
      numberMaskFormat,
      instanceId: null,
      title: 'Añadir capacidad de producción',
      capacityTypes: [
        { name: 'Capacidad propia', value: false },
        { name: 'Capacidad compartida', value: true }
      ],
      form: {
        shared_capacity: [],
        monthly_production_capacity: 0,
        january_production_percentage: 8,
        february_production_percentage: 8,
        march_production_percentage: 8,
        april_production_percentage: 8,
        may_production_percentage: 8,
        june_production_percentage: 8,
        july_production_percentage: 8,
        august_production_percentage: 8,
        september_production_percentage: 9,
        october_production_percentage: 9,
        november_production_percentage: 9,
        december_production_percentage: 9,
        has_shared_capacity: false
      },
      searchBaseProduct: null,
      searchProductSharedCapacity: null,
      baseProducts: [],
      products: [],
      selectedBaseProduct: null,
      selectedProductSharedCapacity: [],
      alertMessages: {
        sku: 'Te recomendamos utilizar tu propio código interno como código de producto para facilitar el manejo del inventario. Si no cuentas con uno, puedes crear acrónimos que te permitan identificar rápidamente el producto con solo ver el código. Por ejemplo, el acrónimo CCZ-500 podría representar Coca Cola Zero 500ml.',
        market_price: 'Registra el precio promedio del producto en el mercado según tus propias definiciones y en función de tus clientes. Este dato es fundamental, ya que el modelo utilizará este valor como referencia para determinar a qué precio un cliente potencial podría realizar una compra, especialmente cuando no tengas información específica sobre el precio que un cliente está dispuesto a pagar.',
        monthly_production_capacity: 'Indica aquí la capacidad máxima de producción o abastecimiento mensual promedio para el producto. Este valor es crucial, ya que actúa como un límite en tus análisis de potencial comercial. Recuerda que la capacidad ingresada puede incluir tanto la producción propia como la capacidad de compra a terceros.',
      },
      validated: false,
      text1: 'Distribución Mensual de Capacidades:',
      text2: 'Configura el porcentaje de capacidad actual para ajustar la estacionalidad de tu operación. Esta herramienta te permite especificar cómo varía tu capacidad mes a mes, reflejando con precisión las fluctuaciones estacionales o los cambios operativos durante diferentes periodos del año. Es especialmente útil si tu capacidad productiva o adquisitiva experimenta variaciones estacionales.'
    }
  },
  methods: {
    async openDialog (instanceId) {
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.instanceId = instanceId
      await this.fetchForm()
      this.dialog = true
    },
    ...mapActions('product', [
      'getProduct',
      'getBaseProduct',
      'listBaseProducts',
      'listProducts',
      'createProduct',
      'editProduct',
      'updateProductProductionCapacity',
    ]),
    onSuccess () {
      this.loading = false
      this.dialog = false
      globalEmitter(WIZARD_STEPS_EVENTS.PRODUCTION_CAPACITY_CREATED)
      this.$emit('save')
    },
    onError ({ error }) {
      this.loading = false
      const data = (error && error.response && error.response.data) || null
      if (!data) {
        this.$toast && this.$toast.error('No pudimos guardar. Revisa tu conexión e intenta de nuevo.')
        return
      }
      let errorMessage = `Ocurrió un error al ${this.instanceId ? 'editar' : 'guardar'} el producto \n`
      const labels = {
        name: 'Nombre',
        base_product: 'Producto base',
        sku: 'SKU',
        market_price: 'Precio de mercado',
        attribute_options: 'Atributos'
      }
      for (const key in error.response.data) {
        errorMessage = errorMessage.concat(`${labels[key]}: ${error.response.data[key].join(', ')} \n`)
      }
      this.$toast.error(errorMessage)
    },
    getAction () {
      return this.instanceId ? this.updateProductProductionCapacity : this.createProduct
    },
    async fetchForm () {
      // Si se está editando un producto
      if (this.instanceId) {
        const { data } = await this.getProduct(this.instanceId)
        await this.handleSelectProductSharedCapacity(data.shared_capacity)
        await this.handleSelectBaseProduct(data.base_product)
        this.title = data.name
        this.form = {
          ...data,
          january_production_percentage: 8,
          february_production_percentage: 8,
          march_production_percentage: 8,
          april_production_percentage: 8,
          may_production_percentage: 8,
          june_production_percentage: 8,
          july_production_percentage: 8,
          august_production_percentage: 8,
          september_production_percentage: 9,
          october_production_percentage: 9,
          november_production_percentage: 9,
          december_production_percentage: 9
        }
      }
      if (this.baseProducts.length === 0) {
        this.handleSearchBaseProduct()
      }
      if (this.products.length === 0) {
        this.handleSearchProductSharedCapacity()
      }
    },
    getData () {
      const {
        shared_capacity,
        monthly_production_capacity,
        january_production_percentage,
        february_production_percentage,
        march_production_percentage,
        april_production_percentage,
        may_production_percentage,
        june_production_percentage,
        july_production_percentage,
        august_production_percentage,
        september_production_percentage,
        october_production_percentage,
        november_production_percentage,
        december_production_percentage,
      } = this.form
      const data = {
        data: {
          shared_capacity,
          monthly_production_capacity,
          january_production_percentage,
          february_production_percentage,
          march_production_percentage,
          april_production_percentage,
          may_production_percentage,
          june_production_percentage,
          july_production_percentage,
          august_production_percentage,
          september_production_percentage,
          october_production_percentage,
          november_production_percentage,
          december_production_percentage
        }
      }
      if (this.instanceId) {
        data.id = this.instanceId
      }
      return data
    },
    handleCancel () {
      this.dialog = false
    },
    async handleSelectBaseProduct (baseProductId) {
      if (!baseProductId) {
        this.form.attribute_options = []
        this.selectedBaseProduct = null
        return
      }
      const { data } = await this.getBaseProduct(baseProductId)
      this.form.attribute_options = data.attributes.map(() => null)
      this.selectedBaseProduct = data
    },
    async handleSelectProductSharedCapacity (productsIds) {
      const { data } = await this.listProducts({ params: { id__in: productsIds.join(',') } })
      this.selectedProductSharedCapacity = data.results
      this.products = this.selectedProductSharedCapacity
    },
    async handleSearchProductSharedCapacity () {
      const params = {
        search: this.searchProductSharedCapacity,
        page_size: 15
      }
      const { data } = await this.listProducts({ params })
      this.products = [...data.results, ...this.products.filter(p => this.form.shared_capacity.includes(p.id))]
    },
    async handleSearchBaseProduct () {
      const params = {
        search: this.searchBaseProduct,
        page_size: 15
      }
      const { data } = await this.listBaseProducts({ params })
      this.baseProducts = data.results
    }
  },
  computed: {
    v () {
      return {
        sku: [validations.isRequired],
        name: [validations.isRequired],
        line_of_business: [validations.isRequired],
        base_product: [validations.isRequired],
        attributes: [validations.isRequired],
        attributeOptionsNames: [validations.isRequired],
        monthly_production_capacity: [validations.isRequired, validations.minOrEqual(0)],
        production_percentage: [validations.isRequired, validations.minOrEqual(0), validations.max(100)],
        production_capacity: [validations.isRequired, validations.minOrEqual(0)],
        unit_cost: [validations.isRequired, validations.minOrEqual(0)]
      }
    },
    state () {
      return {
        monthly_production_capacity: this.form.monthly_production_capacity && this.form.monthly_production_capacity >= 0,
        production_percentage: this.estimatedPercentage <= 100
      }
    },
    isValid () {
      return Object.values(this.state).every(s => s)
    },
    estimatedPercentage () {
      let result = 0

      result += Number(this.form.january_production_percentage) || 0
      result += Number(this.form.february_production_percentage) || 0
      result += Number(this.form.march_production_percentage) || 0
      result += Number(this.form.april_production_percentage) || 0
      result += Number(this.form.may_production_percentage) || 0
      result += Number(this.form.june_production_percentage) || 0
      result += Number(this.form.july_production_percentage) || 0
      result += Number(this.form.august_production_percentage) || 0
      result += Number(this.form.september_production_percentage) || 0
      result += Number(this.form.october_production_percentage) || 0
      result += Number(this.form.november_production_percentage) || 0
      result += Number(this.form.december_production_percentage) || 0
      return result
    }
  },
  watch: {
    searchBaseProduct () {
      this.handleSearchBaseProduct()
    },
    searchProductSharedCapacity () {
      this.handleSearchProductSharedCapacity()
    }
  },
  created () {
    this.fetchForm()
    this.handleSearchBaseProduct = debounce(this.handleSearchBaseProduct, 400)
    this.handleSearchProductSharedCapacity = debounce(this.handleSearchProductSharedCapacity, 400)
  }
}
</script>